import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IntegrationPlatform } from 'voxloud-types/dist/models/integrations';

@Component({
  selector: 'gdp-select-integration-platforms',
  templateUrl: './select-integration-platforms.component.html',
  styleUrls: ['./select-integration-platforms.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectIntegrationPlatformsComponent),
      multi: true
    }
  ]
})
export class SelectIntegrationPlatformsComponent implements OnInit {
  @Input() platforms: IntegrationPlatform[];
  public selectedPlatform: IntegrationPlatform;

  ngOnInit(): void {
    this.selectedPlatform = this.platforms?.[0];
  }

  onChange: any = () => { }
  onTouch: any = () => { }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(val: IntegrationPlatform) {
    if (val) {
      this.selectedPlatform = val;
    }
  }

  public selectPlatform(value: IntegrationPlatform) {
    this.selectedPlatform = value;
    this.onChange(value);
  }
}
